import { Request } from '../../../../../../httpClient/serverApi/requests/Request';
import { IResult } from '../../../../../../httpClient/serverApi/types/IResponse';
import {IPrepExtensionsServerSettings} from '../../../../../../settings/types/ISiteSettingsForSiteAdmin';

export interface IUpdatePrepExtensionsServerSettingsParams {
  prepExtensionsServerSettings: IPrepExtensionsServerSettings;
}

export type IUpdatePrepExtensionsServerSettingsResult = IResult & IPrepExtensionsServerSettings;

export class UpdatePrepExtensionsServerSettingsRequest extends Request<IUpdatePrepExtensionsServerSettingsParams, IUpdatePrepExtensionsServerSettingsResult> {
  constructor(params: IUpdatePrepExtensionsServerSettingsParams) {
    super('updatePrepExtensionsServerSettings', params);
  }
}
